import {
  EgressLight,
  FireDrillFormData,
  FireExtinguisher,
  SmokeDetector,
} from "../../../types";

export type MonthlyNonBehavioralHealthFireDrillFormData = FireDrillFormData & {
  signalType: string;
  fireParticipantsStaff: string;
  fireParticipantsPersonsSupported: string;
  meetingPlace: string;
  evacDurationMinutes: number;
  evacDurationSeconds: number;
  exitUsed: string;
  drillStatus: string;
  drillStatusOther: string;
  fireComments: string;
  disasterStartTime: Date;
  disasterParticipantsStaff: string;
  disasterParticipantsPersonsSupported: string;
  disasterIssues: string;
  disasterIssueDescription: string;
  disasterComments: string;
  extinguishers: FireExtinguisher[];
  smokeDetectors: SmokeDetector[];
  egressLights: EgressLight[];
  sprinklerHeadsStorage: string;
  sprinklerChecked: string;
  sprinklerClearance: string;
  sprinklerIssues: string;
  sprinklerIssueDescription: string;
  waterTempLocation: string;
  waterTemperature: number;
  waterTempLocation2: string;
  waterTemperature2: number;
  fireDepartmentConnection: string;
  exitVaried: string;
  firstAid: string;
  emergencyPlan: string;
  emergencyPlanFireChief: string;
  emergencyPlanAgencyContacts: string;
  emergencyPlanSupportedContacts: string;
  emergencySupplies: string;
  egressClearance: string;
  hotWaterClearance: string;
  emergencyShutOff: string;
  alarm: string;
  alarmSent: string;
};

export type MonthlyFireDrillFormLabels =
  MonthlyNonBehavioralHealthFireDrillFormData &
    FireExtinguisher &
    SmokeDetector &
    EgressLight;

export enum DisasterTypes {
  Snow = "Snow/Blizzard",
  Storm = "Storm/Power Loss",
  Flood = "Flooding",
  Tornado = "Tornado",
  Hurricane = "Hurricane",
  LockDown = "Lock Down Facility",
}

export enum FireLocations {
  Bedroom = "Bedroom/Office",
  Kitchen = "Kitchen/Break Room",
  Laundry = "Laundry/Storage",
  LivingRoom = "Living Room/ Conference Area",
  Bathroom = "Bathroom (Trash)",
  MainEntrance = "Main Entrance / Exit",
}

export enum Shifts {
  first = "1st Shift: 7:00AM-2:59PM",
  second = "2nd Shift: 3:00PM-10:59PM",
  third = "3rd Shift: 11:00PM-6:59AM",
}
